import { z } from "zod/v4";

export const ScheduleActionTypeList = ["start", "pause", "end"] as const;
export type ScheduleAction = (typeof ScheduleActionTypeList)[number];

export const ScheduleDtoSchema = z.object({
  id: z.uuid(),
  experienceId: z.uuid(),
  action: z.enum(ScheduleActionTypeList),
  executionTime: z.number(),
});

export type ScheduleDto = z.infer<typeof ScheduleDtoSchema>;
